import React from 'react';
import { Grid, TextField, Checkbox, FormControlLabel, Button, Autocomplete } from '@mui/material';
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material';
import { getAllZipcodeData, getZipCodes } from '../../../API/routePlannerAPI'; // Adjust the import path



const ClientAddress = ({ clientAddresses, fullZipCodeData, barangays, cities, zipCodes, handleAddressChange, handleBarangayChange, handleCityChange, handleAddressCheckboxChange, handleAddAddress, handleRemoveAddress }) => {

    return (
        <>
            <Grid container spacing={6}>
                {clientAddresses.map((clientAddress, index) => (
                    <React.Fragment key={index}>
                        {/* Generic form template for Address */}
                        <Grid item xs={12}>
                            <Grid container spacing={3}>
                                {/* House/Unit Street */}
                                <Grid item xs={3}>
                                    <TextField
                                        label="House/Unit Street"
                                        name={`house_unit_street ${index + 1}`}
                                        value={clientAddress.house_unit_street}
                                        onChange={(e) =>
                                            handleAddressChange(index, 'house_unit_street', e.target.value)
                                        }
                                        fullWidth
                                        multiline
                                        rows={4.5}
                                        required
                                    />
                                </Grid>
                                
                                <Grid item xs={4}>
                                    <Grid container spacing={3} >
                                        {/* Barangay */}
                                        <Grid item xs={12}>
                                            <Autocomplete
                                                options={barangays} // Provide barangay options
                                                getOptionLabel={(option) => option}
                                                value={clientAddress.barangay || ''}
                                                onChange={(event, newValue) => handleBarangayChange(index, newValue)}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Barangay"
                                                        fullWidth
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            // sx: { fontSize: '0.875rem' },
                                                        }}
                                                        // InputLabelProps={{ sx: { fontSize: '0.875rem' } }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        {/* Zipcode */}
                                        <Grid item xs={6}>
                                            <FormControl fullWidth variant="outlined">
                                                <InputLabel id={`zipcode-label-${index}`} >
                                                    Zip Code
                                                </InputLabel>
                                                <Select
                                                    labelId={`zipcode-label-${index}`}
                                                    label="Zip Code"
                                                    name={`zipcode ${index + 1}`}
                                                    value={clientAddress.zipcode || ''}
                                                    onChange={(e) => handleAddressChange(index, 'zipcode', e.target.value)}
                                                    disabled={!clientAddress.city}
                                                >
                                                    <MenuItem value="" disabled>
                                                        Select Zip Code
                                                    </MenuItem>
                                                    {fullZipCodeData
                                                        .filter(
                                                            (data) =>
                                                                data.barangay === clientAddress.barangay &&
                                                                data.city === clientAddress.city
                                                        )
                                                        .map((data, idx) => (
                                                            <MenuItem key={idx} value={data.zip_code}>
                                                                {data.zip_code}
                                                            </MenuItem>
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        {/* Area */}
                                        <Grid item xs={6}>
                                            <TextField
                                                name={`area ${index + 1}`}
                                                label="Area"
                                                value={clientAddress.area}
                                                onChange={(e) => handleAddressChange(index, 'area', e.target.value)}
                                                fullWidth
                                            />
                                        </Grid>


                                    </Grid>
                                </Grid>
                    
                                <Grid item xs={3}>
                                    <Grid container spacing={3} >
                                        {/* City */}
                                        <Grid item xs={12}>
                                            <FormControl fullWidth variant="outlined">
                                                <InputLabel id={`city-label-${index}`} >
                                                    City
                                                </InputLabel>
                                                <Select
                                                    labelId={`city-label-${index}`}
                                                    label="City"
                                                    name={`city ${index + 1}`}
                                                    value={clientAddress.city || ''}
                                                    onChange={(e) => handleCityChange(index, e.target.value)}
                                                    disabled={!clientAddress.barangay}
                                                >
                                                    <MenuItem value="" disabled>
                                                        Select City
                                                    </MenuItem>
                                                    {[...new Set(
                                                        fullZipCodeData
                                                            .filter((data) => data.barangay === clientAddress.barangay)
                                                            .map((data) => data.city)
                                                    )].map((city, idx) => (
                                                        <MenuItem key={idx} value={city}>
                                                            {city}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        {/* Billing Address */}
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name="billing_address"
                                                        checked={clientAddress.billing}
                                                        onChange={() => handleAddressCheckboxChange(index)}
                                                    />
                                                }
                                                label="Billing Address"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>                                

                                {/* Remove Address Button */}     
                                <Grid item xs={2} >                                    
                                    {clientAddresses.length > 1 && (
                                        <Grid item xs={12}>
                                            <Button
                                                variant="outlined"
                                                color="secondary"
                                                onClick={() => handleRemoveAddress(index)}
                                                size="small"
                                                sx={{
                                                    color: "#FF4C4C",
                                                    borderColor: "#FF4C4C",                                                        
                                                }}
                                            >
                                                Remove
                                            </Button>
                                        </Grid>
                                    )}
                                </Grid>

                            </Grid>
                        </Grid>
                    </React.Fragment>
                ))}

                {/* Add Address Button */}
                <Grid item xs={12}>
                    <Button 
                        variant="contained"
                        color="primary" 
                        onClick={handleAddAddress} 
                        size="small"
                        >
                        Add Address
                    </Button>
                </Grid>
            </Grid>

        </>
    );
};

export default ClientAddress;
